import {StorageOPEEnum} from "./StorageOPEEnum";

import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";

/**
 * O Inner Class
 */
class O {
  file!: FileStorageDTO;
}

class FileStorageDTO {
  /**
   * Directory in cui viene salvato il file sullo storage
   */
  directory!: string;

  /**
   * Id univoco e nome del file all'interno della directory
   */
  fileId!: string;

  /**
   * Chiave del file sul bucket di S3
   */
  objKey!: string

}


class I {
  file!: File;
  mimeType!: string;
  fileDir!: string;
  fileId!: string;
}


export class PutFileCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(StorageOPEEnum.PutFile);
    this.i = new I();
    this.o = new O();
  }
}
